export const BODY = [
    {
        id: 0,
        name: "Đấm Móc",
        quantity: "10 C"
    },
    {
        id: 1,
        name: "Đấm Thẳng",
        quantity: "10 C"
    },
    {
        id: 2,
        name: "Đấm Giữa",
        quantity: "10 C"
    },
    {
        id: 3,
        name: "Đấm Ngược",
        quantity: "10 C"
    },
    {
        id: 4,
        name: "Khóa Tay",
        quantity: "10 C"
    },
    {
        id: 5,
        name: "Lên Chỏ",
        quantity: "10 C"
    },
    {
        id: 6,
        name: "Chỏ Ngang",
        quantity: "10 C"
    },
    {
        id: 7,
        name: "Chỏ Ngược",
        quantity: "10 C"
    },
    {
        id: 8,
        name: "Chỏ Trên",
        quantity: "10 C"
    },
    {
        id: 9,
        name: "Thủ Vạn Tay",
        quantity: "10 C"
    },
    {
        id: 10,
        name: "Đạp",
        quantity: "10 C"
    },
    {
        id: 11,
        name: "Đá",
        quantity: "10 C"
    },
    {
        id: 12,
        name: "Đá Xoay",
        quantity: "10 C"
    },
    {
        id: 13,
        name: "Đạp Xoay",
        quantity: "10 C"
    },
    {
        id: 14,
        name: "Đá móc xuống",
        quantity: "10 C"
    },
    {
        id: 15,
        name: "Khóa Chân",
        quantity: "10 C"
    },
    {
        id: 16,
        name: "Lên đùi",
        quantity: "10 C"
    },
    {
        id: 17,
        name: "Ngang đùi",
        quantity: "10 C"
    },
    {
        id: 18,
        name: "Trái né",
        quantity: "10 C"
    },
    {
        id: 19,
        name: "Đạp trước sau 2 chân",
        quantity: "10 C"
    },
    {
        id: 20,
        name: "Nhảy đạp 2 chân",
        quantity: "10 C"
    },
    {
        id: 21,
        name: "Nhảy đá 2 chân",
        quantity: "10 C"
    },
    {
        id: 22,
        name: "Đỡ đòn bằng bàn chân",
        quantity: "10 C"
    },
    {
        id: 23,
        name: "Nhảy đá xoay 2 lần",
        quantity: "10 C"
    },
    {
        id: 24,
        name: "Phải né",
        quantity: "10 C"
    },
    {
        id: 25,
        name: "Lui né",
        quantity: "10 C"
    },
    {
        id: 26,
        name: "Khom người né",
        quantity: "10 C"
    },
    {
        id: 27,
        name: "Nhảy chỏ chân",
        quantity: "10 C"
    },
    {
        id: 28,
        name: "Đỡ đòn bằng cù chỏ",
        quantity: "10 C"
    },
    {
        id: 29,
        name: "Nhảy né",
        quantity: "10 C"
    },
    {
        id: 30,
        name: "Lặn Nước",
        quantity: "100 M"
    },
    {
        id: 31,
        name: "Bơi Xải",
        quantity: "100 M"
    },
    {
        id: 32,
        name: "Gập Bụng",
        quantity: "20 C"
    },
    {
        id: 33,
        name: "Trồng Chuối",
        duration: "100 S"
    },
    {
        id: 34,
        name: "Đo Sàn",
        duration: "100 S"
    },
    {
        id: 35,
        name: "Đứng Tấn",
        duration: "100 S"
    },
    {
        id: 36,
        name: "Hít Đất",
        quantity: "60 C"
    },
    {
        id: 37,
        name: "Hít đất chân",
        quantity: "40 C"
    },
    {
        id: 38,
        name: "Xây cầu lên xuống",
        quantity: "20 C"
    },
    {
        id: 39,
        name: "Duỗi chân trên cao",
        quantity: "20 C"
    },
    {
        id: 40,
        name: "Parkour",
        quantity: "20 C"
    },
    {
        id: 41,
        name: "Giảo Hoạt Đao(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 42,
        name: "Phóng Đao(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 43,
        name: "Đâm Trên Giữa Dưới(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 44,
        name: "Chéo Phải Xuống Trái(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 45,
        name: "Chéo Trái Xuống Phải(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 46,
        name: "Chéo Phải Lên Trái(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 47,
        name: "Chéo Trái Lên Phải(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 48,
        name: "Đâm Bên Phải(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 49,
        name: "Chém Ngang Phải Sang Trái(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 50,
        name: "Đâm Bên Trái(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 51,
        name: "Chém Ngang Trái Sang Phải(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 52,
        name: "Chém Trên Xuống(Thuận Nghịch)",
        quantity: "1 C"
    },
    {
        id: 53,
        name: "Chém Dưới Lên(Thuận Nghịch)",
        quantity: "1 C"
    }
]
